var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('BasicHeading',{attrs:{"title":"Select Previous Schedule"}}),_c('schedule-server-table-fillable',{attrs:{"filter_day":_vm.previous_week,"schedule_id":_vm.schedule_id,"schedule_type":_vm.schedule_type,"collection_status":"Approved"},on:{"rowClicked":_vm.handleSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }